import { Radio } from '@mantine/core';

interface RadioButtonGroupProps {
  name?: string;
  label?: string;
  description?: string;
  required?: boolean;
  withAsterisk?: boolean;
  onChange?: (value: string) => void;
  value?: string;
  data: {
    value?: string | number;
    label?: React.ReactNode;
  }[];
}

export default function RadioButtonGroup({
  name,
  label,
  description,
  required,
  withAsterisk,
  onChange,
  value,
  data,
}: RadioButtonGroupProps) {
  return (
    <Radio.Group
      value={value}
      onChange={onChange}
      name={name}
      label={label}
      description={description}
      required={required}
      withAsterisk={withAsterisk}
    >
      {data.map(opt => (
        <Radio key={opt.value} value={opt.value} label={opt.label} />
      ))}
    </Radio.Group>
  );
}
